import { useEffect, useState } from "react";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ExpenseEditDialog = ({ expense, onClose, onSaved }) => {
  const [f, setF] = useState(null);
  useEffect(() => { if (expense) setF({ label: expense.label, amount: expense.amount, note: expense.note || "", date: (expense.date || expense.created_at).slice(0, 10) }); }, [expense]);
  const save = async () => {
    try { await api.put(`/cash/expenses/${expense.id}`, { warehouse_id: expense.warehouse_id, amount: parseFloat(f.amount), label: f.label, note: f.note, date: f.date }); toast.success("Frais modifié"); onSaved?.(); onClose(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!expense || !f) return null;
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="expense-edit-dialog">
        <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Pencil size={18} /> Modifier le frais — {expense.warehouse_name}</DialogTitle></DialogHeader>
        <div className="grid gap-2">
          <Input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="expense-edit-date" />
          <Input placeholder="Libellé" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} data-testid="expense-edit-label" />
          <Input type="number" min={0} placeholder="Montant" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="expense-edit-amount" />
          <Input placeholder="Note" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} data-testid="expense-edit-note" />
          <div className="flex justify-end gap-2"><Button variant="outline" onClick={onClose} data-testid="expense-edit-cancel">Annuler</Button><Button className="bg-[#059669] hover:bg-[#047857]" disabled={!f.label.trim() || !(parseFloat(f.amount) > 0)} onClick={save} data-testid="expense-edit-save">Enregistrer</Button></div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
